export const enum CashbackLevelType {
  PREVIOUS = 'previous',
  CURRENT = 'current',
  NEXT = 'next',
}
